export default {
  getClient: state => state.data
}



// WEBPACK FOOTER //
// ./src/store/modules/client/getters.js